import { render } from "./SendTestMail.vue?vue&type=template&id=25b0e8a0"
import script from "./SendTestMail.vue?vue&type=script&lang=js"
export * from "./SendTestMail.vue?vue&type=script&lang=js"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__